export const BASIC_SERIAL_CONNECTION_ID = 'basic-serial'
export const LEGACY_SERIAL_CONNECTION_ID = 'legacy-serial'

/**
 * Prefixed to keep user-chosen names out of the synthetic id namespace: without it, a connection
 * named `legacy-serial` would collide with a serial connection.
 */
const NAMED_MODBUS_CONNECTION_ID_PREFIX = 'named-modbus:'

export function namedModbusConnectionId(name: string) {
  return NAMED_MODBUS_CONNECTION_ID_PREFIX + name
}
